import React, { Fragment, useState } from 'react';
import styled from 'styled-components';

import Icon from 'components/ui/Icon';
import Select from 'components/ui/SelectField';
import CtaCard from 'components/ui/CtaCard';
import { default as AntDrawer } from 'components/ui/Drawer';

import MultiselectAdvancedDrawer from './MultiselectAdvancedDrawer';

import { getTranslatedString } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';

const DefaultSelectedOptions = optionsSelected =>
  getTranslatedString('landlordPortal.multiselectAdvanced.selected', {
    count: optionsSelected.length,
  });

const FullWidthSelect = styled(Select)`
  width: 100%;
`;

const StyledContainer = styled.div`
  display: flex;
`;

const StyledRightAlign = styled.div`
  margin-left: auto;
`;

export const StyledLink = styled(CtaCard)`
  flex-grow: 1;
  padding: 0;
  color: ${colors.PURE_BLUE};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
  text-align: right;
`;

export const StyledIcon = styled(Icon)`
  font-size: 16px;
`;

const StyledError = styled.div`
  color: ${colors.YUHU_RED};
  line-height: 1.5;
`;

const MultiselectAdvanced = ({
  options,
  filterOptions,
  handleFilter,
  fetchReviewState,
  fetchingReviewState,
  reviewStateOptions,
  selectOptionsVerbiage,
  onChange,
  value,
  name,
  error,
  verbiage = {},
  ...rest
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const renderSelectedOptions = verbiage.selectOptionsVerbiage || DefaultSelectedOptions;

  return (
    <Fragment>
      <FullWidthSelect
        mode="multiple"
        maxTagCount={0}
        maxTagPlaceholder={renderSelectedOptions}
        allowClear
        onChange={onChange}
        value={value}
        name={name}
        {...rest}
      >
        {options.map(option => (
          <Select.Option
            key={`multiselect-advanced-option-${option.attributes.value}`}
            value={option.attributes.value}
          >
            {option.attributes.label}
          </Select.Option>
        ))}
      </FullWidthSelect>
      {filterOptions && (
        <StyledContainer>
          {error && <StyledError>{error}</StyledError>}
          <StyledRightAlign>
            <StyledLink onClick={() => setDrawerOpen(true)} type="button">
              <StyledIcon type="filter" />{' '}
              {getTranslatedString('landlordPortal.multiselectAdvanced.advancedFilters')}
            </StyledLink>
          </StyledRightAlign>
        </StyledContainer>
      )}

      <AntDrawer
        maskClosable={false}
        keyboard
        visible={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        closable={false}
        width={700}
      >
        {drawerOpen && (
          <MultiselectAdvancedDrawer
            handleClose={() => setDrawerOpen(false)}
            selectedOptions={value}
            handleSelect={onChange}
            filterOptions={filterOptions}
            options={options}
            verbiage={verbiage}
            handleFilter={handleFilter}
            name={name}
            fetchReviewState={fetchReviewState}
            fetchingReviewState={fetchingReviewState}
            reviewStateOptions={reviewStateOptions}
          />
        )}
      </AntDrawer>
    </Fragment>
  );
};

export default MultiselectAdvanced;
